import React, { Component } from "react";
import { Col, Row, CardTitle, Card, CardHeader } from "reactstrap";
import { DeviceService } from "../../services/deviceService";
import { connect } from "react-redux";
import { Search } from "../../containers";
import SearchInput, { createFilter } from "react-search-input";
import PropTypes from "prop-types";
import moment from "moment";
const KEYS_TO_FILTERS = ["name", "computerId", "version", "model", "os"];

let deviceService = new DeviceService();

class THead extends Component {
  render() {
    return (
      <thead>
        <tr>
          <th>Usuario</th>
          <th>Identificador Dispositivo</th>
          <th>Version</th>
          <th>Modelo</th>
          <th>Sistema Operativo</th>
          <th>Fecha Inicio Sincronizacion</th>
          <th>Termino</th>
        </tr>
      </thead>
    );
  }
}

class Device extends Component {
  containsWhitespace(str) {
    return Boolean(str.match(/\s/));
  }
  getOS(computerId, osStr, version){
    if(osStr) { //if exist os String
      return osStr;
    } else if(version) { // if exist version, calculate version android vs windows
      let majorVersion = Number(version[0]);
      if(majorVersion > 5) return 'Windows';
      else return 'Android';
    } else if(computerId) { // if no other info exist, try with some keywords

      // detect if have spaces on name
      if(this.containsWhitespace(computerId)) return 'Windows';

      const list = ['-win', '-PC', 'Fashions', 'bubba', 'talca', 'corona'];
      // detect some keyword
      for(let i = 0; i < list.length; i++){
        if(computerId.includes(list[i])) return 'Windows';
      }

      return 'Android';
    }

    return '';
  }
  render() {
    let item = this.props.item;
    return (
      <tr>
        <td>
          {item.name}
        </td>
        <td>{item.computerId}</td>
        <td>{item.version}</td>
        <td>{item.model}</td>
        <td>{this.getOS(item.computerId, item.os, item.version)}</td>
        <td>
          {item.modifiedOn
            ? moment(item.modifiedOn).format(
                "DD/MM/YYYY HH:mm"
              )
            : ""}
        </td>
        <td>
          {item.lastConnection
            ? moment(item.lastConnection).format("HH:mm")
            : ""}
        </td>
      </tr>
    );
  }
}

Device.contextTypes = {
  getNotificationSystem: PropTypes.func.isRequired
};

const MINUTE = 60 * 1000;
const TEN_MINUTES = MINUTE * 10
const HOUR = MINUTE * 60;

class DeviceConnector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      searchTerm: ""
    };
    this.mounted = true;
    this.loadData(this);
    this.searchUpdated = this.searchUpdated.bind(this);
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  searchUpdated(term) {
    this.setState({ searchTerm: term });
  }
  loadData(self) {
    deviceService
      .reload()
      .then(function() {
        if (self.mounted)
          self.setState({
            loading: false
          });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  isConnected(lastConnection) {
    if (lastConnection) {
      let date = new Date();
      let connectionDate = new Date(lastConnection);

      let dif = date - connectionDate;
      if (dif < TEN_MINUTES) return true;
      else if (dif > HOUR)
        return false;
      return true;
    }
    return false;
  }

  render() {
    let filtered = this.props.data;
    filtered = filtered.filter(x => this.isConnected(x.lastConnection));

    filtered = filtered.filter(
      createFilter(this.state.searchTerm, KEYS_TO_FILTERS)
    );
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <Row>
              <Col sm="4">
                <CardTitle className="mb-0">Dispositivos</CardTitle>
              </Col>
              <Col sm="4" className="d-sm-inline-block">
                <SearchInput
                  className="search-input input-group"
                  inputClassName="form-control"
                  placeholder="Buscar..."
                  onChange={this.searchUpdated}
                />
              </Col>
            </Row>
          </CardHeader>
          <Search
            Thead={THead}
            table={true}
            data={filtered}
            ObjectTemplate={Device}
            loading={this.state.loading}
            bordered={false}
            striped={false}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { data: state.devices };
};

const Devices = connect(
  mapStateToProps,
  null
)(DeviceConnector);

export default Devices;
